"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.localStorage = exports.sessionStorage = void 0;

/**
 *
 * 本地storage操作模块
 * @module
 */
var methods = ['removeItem', 'setItem', 'getItem'];
var stores = ['sessionStorage', 'localStorage'];
var mod = {};
methods.forEach(function (method) {
  stores.forEach(function (store) {
    mod[store] = mod[store] || {};

    mod[store][method] = function () {
      try {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return window[store][method].apply(window[store], args);
      } catch (e) {}
    };
  });
});
/**
 * @export
 * @type {Object}
 */

var sessionStorage = mod.sessionStorage;
/**
 * @export
 * @type {Object}
 */

exports.sessionStorage = sessionStorage;
var localStorage = mod.localStorage;
exports.localStorage = localStorage;
var _default = mod;
exports["default"] = _default;